import Route from '@ember/routing/route';
import type { Model as AuthenticatedModel } from 'frontend-payments/routes/authenticated';
import type { ModelFrom } from 'frontend-payments/utils/routes';

export type Model = ModelFrom<AuthenticatedOverviewRoute>;

export default class AuthenticatedOverviewRoute extends Route {
  model(): AuthenticatedModel {
    return this.modelFor('authenticated') as AuthenticatedModel;
  }
}
